import React from 'react';

const breakPointClassNames = (greaterThan, lessThan, useNewBreakpoints) => {
  const greaterThanClassName = greaterThan ? `display-on-greater-than-${useNewBreakpoints ? 'breakpoint-' : ''}${greaterThan}` : '';
  const lessThanClassName = lessThan ? `display-on-less-than-${useNewBreakpoints ? 'breakpoint-' : ''}${lessThan}` : '';
  return `${greaterThanClassName} ${lessThanClassName}`;
};

const validProps = (greaterThan, lessThan, children) => {
  return (greaterThan || lessThan) && React.isValidElement(children);
};

const DisplayOnBreakpoint = ({
  children,
  greaterThan,
  lessThan,
  useNewBreakpoints
}) => {
  const child = React.Children.only(children);

  if (!validProps(greaterThan, lessThan, children)) {
    return child;
  } // @ts-ignore


  const childClassName = child.props.className;
  const className = childClassName ? breakPointClassNames(greaterThan, lessThan, useNewBreakpoints).concat(' ').concat(childClassName) : breakPointClassNames(greaterThan, lessThan, useNewBreakpoints); // @ts-ignore

  return React.cloneElement(child, {
    className
  });
};

export default DisplayOnBreakpoint;
//# sourceMappingURL=index.js.map
